module.exports = __webpack_public_path__ + "media/images/ic-camera-666489f872307444172fcfe1b6b49282.svg";